/**
 * "Go to ID" in the top bar: paste an ID an employee quoted
 * ("d2de109f") and land on the page that shows it (`/go/<id>`).
 */
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export function GoToId() {
  const navigate = useNavigate();
  const [value, setValue] = useState("");
  return (
    <form
      className="topbar-go"
      role="search"
      onSubmit={(e) => {
        e.preventDefault();
        const id = value.trim();
        if (!id) return;
        navigate(`/go/${encodeURIComponent(id)}`);
        setValue("");
      }}
    >
      <input
        className="input"
        aria-label="Go to ID"
        placeholder="Go to ID"
        title="Paste an ID an employee quoted, e.g. d2de109f"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        spellCheck={false}
        autoComplete="off"
      />
    </form>
  );
}
